import guards from './guards.js';

const Login = () =>
    import(/* webpackChunkName: "auth-bundle" */ '@S/Login.vue');
const ForgotPassword = () =>
    import(/* webpackChunkName: "auth-bundle" */ '@S/ForgotPassword.vue');
const ResetEmailSent = () =>
    import(/* webpackChunkName: "auth-bundle" */ '@S/ResetEmailSent.vue');
const PasswordReset = () =>
    import(/* webpackChunkName: "auth-bundle" */ '@S/PasswordReset.vue');
    const PasswordSet = () =>
    import(/* webpackChunkName: "auth-bundle" */ '@S/PasswordSet.vue');
const PasswordResetSuccess = () =>
    import(/* webpackChunkName: "auth-bundle" */ '@S/PasswordResetSuccess.vue');
const VerifyAccount = () =>
    import(/* webpackChunkName: "auth-bundle" */ '@S/VerifyAccount.vue');
const VerifyCallback = () =>
    import(/* webpackChunkName: "auth-bundle" */ '@S/VerifyCallback.vue');
const Register = () =>
    import(/* webpackChunkName: "auth-bundle" */ '@S/Register.vue');
const Landing = () =>
    import(/* webpackChunkName: "auth-bundle" */ '@S/Landing.vue');

export default [
    {
        path: '/',
        name: 'login',
        component: Login,
        beforeEnter: guards.login
    },
    {
        path: '/logout',
        name: 'logout',
        beforeEnter: guards.logout
    },
    {
        path: '/landing',
        name: 'landing',
        component: Landing,
        beforeEnter: guards.landing
    },
    {
        path: '/password/forgot',
        name: 'forgot-password',
        component: ForgotPassword
    },
    {
        path: '/password/email-sent',
        name: 'reset-email-sent',
        component: ResetEmailSent,
        beforeEnter: guards.resetEmailSent
    },
    {
        path: '/password/reset/:token',
        name: 'password-reset',
        component: PasswordReset,
        beforeEnter: guards.passwordReset
    },
    {
        path: '/password/set/:token',
        name: 'password-set',
        component: PasswordSet,
        beforeEnter: guards.passwordReset
    },
    {
        path: '/password/reset-success',
        name: 'password-reset-success',
        component: PasswordResetSuccess
    },
    {
        path: '/account/verify',
        name: 'verify-account',
        component: VerifyAccount,
        beforeEnter: guards.verify
    },
    {
        path: '/email/verify',
        name: 'verify-email-callback',
        component: VerifyCallback,
        beforeEnter: guards.verifyCallback
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        beforeEnter: guards.register
    }
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/auth.js